import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import useAuthStore from "@/lib/useAuthStore";
import { AlignJustify, Plane, School} from "lucide-react";
import Link from "next/link";
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { formatToRupee } from "@/lib/internalApis";
import WalletCreditInfo from '@/components/layout/WalletCreditInfo';

const MenuBar = () => {

  const { user }: any = useAuthStore();
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline">
          <AlignJustify className="w-[15px]" />
        </Button>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>

        <div className="mt-3">
          
            <div className="py-3 px-8 hover:bg-gray-200">
            <SheetClose asChild>
              <Link href="/flight" className="block font-bold text-[#022f5d]">
                <span className="flex items-center">
                  <Plane className="mr-2" />
                  Flight
                </span>
              </Link>
           </SheetClose>
            </div>
         

          
            <div className="py-3 px-8 hover:bg-gray-200">
            <SheetClose asChild>
              <Link href="/hotel" className="block font-bold text-[#022f5d]">
                {" "}
                <span className="flex items-center">
                  <School className="mr-2" />
                  Hotel
                </span>{" "}
              </Link>
              </SheetClose>
            </div>
         
        </div>
        <div className="mt-10">
        {(user?.settings?.CORPORATE_ADMIN || user?.settings?.NORMAL_USER) && (user?.settings?.CORPORATE_ADMIN?.relationShipManager?.name || 
                             user?.settings?.NORMAL_USER?.relationShipManager?.name) && (
            <div className="mb-2">
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="relationship-manager">
                  <AccordionTrigger className="text-[#084A76] text-[14px] py-1">
                  Your TravelFirst Guide
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="text-sm space-y-2 p-3">
                      <div className="gap-2">
                        <div className="flex gap-5">
                          <p className="text-[12px]">
                            {user?.settings?.CORPORATE_ADMIN?.relationShipManager?.name || 
                             user?.settings?.NORMAL_USER?.relationShipManager?.name}
                          </p>
                        </div>
                        <div className="flex gap-3">
                          <p className="text-[12px]">
                          {user?.settings?.CORPORATE_ADMIN?.relationShipManager?.mobile || 
                             user?.settings?.NORMAL_USER?.relationShipManager?.mobile}
                          </p>
                        </div>
                        <div className="flex gap-5">
                          <p className="text-[12px]">
                            {user?.settings?.CORPORATE_ADMIN?.relationShipManager?.email || 
                             user?.settings?.NORMAL_USER?.relationShipManager?.email}
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          )}
          
        {(user?.role_type === "NORMAL_USER" || user?.role_type === "CORPORATE_ADMIN") && (
            <div className="py-2">
              <WalletCreditInfo 
                walletBalance={user?.wallet_balance} 
                walletLimit={user?.wallet_limit}
                availableCredit={user?.available_credit}
              />
            </div>
          )}
          
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MenuBar;